export const getSDKVersion = () => '9.1.0';
